import {Option, Select} from "@components/Select";
import {
  CalendarToday,
  CalendarViewDay,
  CalendarViewMonth,
  CalendarViewWeek,
} from "@mui/icons-material";
import {translate} from "@util";
import {View} from "react-big-calendar";

const ViewSwitcher = ({
  view,
  disabled = false,
  onChange,
}: {
  view: View;
  disabled?: boolean;
  onChange: (view: View) => void;
}) => {
  const options: Option<View>[] = [
    {
      icon: CalendarViewDay,
      label: translate("calendar.day"),
      value: "day",
    },
    {
      icon: CalendarViewWeek,
      label: translate("calendar.week"),
      value: "week",
    },
    {
      icon: CalendarViewMonth,
      label: translate("calendar.month"),
      value: "month",
    },
    {
      icon: CalendarToday,
      label: translate("calendar.agenda"),
      value: "agenda",
    },
  ];

  return (
    <Select<View>
      value={view}
      options={options}
      onChange={onChange}
      collapsable
      disabled={disabled}
    />
  );
};

export {ViewSwitcher};
